import React from 'react';

import CommonModal from '../../../components/common-modal/CommonModal';
import BackgroundImage from '../../../activ8/components/content-media/background-image/BackgroundImage';

import scss from './ImageModal.module.scss';

function ImageModal({ isOpen, onClose, src, alt }) {
  return (
    <CommonModal isOpen={isOpen} onClose={onClose} isAnimated>
      <div className={scss.previewModal}>
        <BackgroundImage src={src} alt='background blurred image' />
        <img src={src} alt={alt} className={scss.slideImage} role='presentation' />
      </div>
    </CommonModal>
  );
}

export default ImageModal;
